import { render, staticRenderFns } from "./promotionDrawer.vue?vue&type=template&id=71f53b7e&scoped=true"
import script from "./promotionDrawer.vue?vue&type=script&lang=js"
export * from "./promotionDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f53b7e",
  null
  
)

export default component.exports